package com.swetdot.swetgram.data.media

import com.swetdot.swetgram.protocol.dto.UploadLimits
import kotlinx.coroutines.flow.StateFlow

const val MAX_VOICE_DURATION_MS: Long = UploadLimits.VOICE_MAX_DURATION_MS
const val MIN_VOICE_DURATION_MS: Long = UploadLimits.VOICE_MIN_DURATION_MS

class RecordedVoice(
    val bytes: ByteArray,
    val durationMs: Long,
    val waveform: List<Int>,
) {
    val sizeBytes: Long get() = bytes.size.toLong()
}

sealed interface VoiceCaptureState {
    data object Idle : VoiceCaptureState
    data object RequestingPermission : VoiceCaptureState
    data object PermissionDenied : VoiceCaptureState
    data class Active(
        val elapsedMs: Long,
        val amplitude: Int,
        val paused: Boolean,
    ) : VoiceCaptureState
    data object Failed : VoiceCaptureState
}

/** Platform recorder; Android provides Ogg/Opus, other platforms leave the feature unwired. */
interface VoiceRecorder {
    val state: StateFlow<VoiceCaptureState>
    suspend fun start(): Boolean
    fun pause()
    fun resume()
    suspend fun stop(): RecordedVoice?
    fun cancel()
}

